module.exports = __webpack_public_path__ + "img/icon_footer_record.6c0fb2e1.svg";